import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b15519c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-sm mt-2" }, "Получение информации о предыдущей проверке...", -1))
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = {
  key: 0,
  class: "fas fa-check mr-3"
}
const _hoisted_4 = {
  key: 1,
  classs: "fas fa-times mr-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!

  return (_ctx.message || _ctx.loading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["BeforeCheckedInformation", {
            'border-green-400': _ctx.isConfirmed,
            'border-red-400': _ctx.isDeclined,
        }])
      }, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_loader, { class: "primary" }),
              _hoisted_1
            ], 64))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass({
                'text-green-400': _ctx.isConfirmed,
                'text-red-400': _ctx.isDeclined,
            })
            }, [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.isConfirmed)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_3))
                  : (_openBlock(), _createElementBlock("i", _hoisted_4)),
                _createElementVNode("span", null, _toDisplayString(_ctx.message), 1)
              ])
            ], 2))
      ], 2))
    : _createCommentVNode("", true)
}